// inspired by https://stackoverflow.com/questions/9461621
// eslint-disable-next-line no-unused-vars
export const SCALE_SYMBOLS = ['', 'K', 'M', 'B'];
export const UNITS_MAP = { k: 1, m: 2, b: 3 };
export const SORT_DEFAULT = 'DEFAULT';
export const SORT_ALPHABETIC = 'ALPHABETIC';
export const SORT_TIME = 'TIME';

export const EMPTY_VALUE = '(Blank)';
export const EMPTY_VALUE_KEY = '__blank__';
export const EMPTY_VALUE_NULL = '__blank_null__';
export const EMPTY_VALUE_SPACE = '__blank_space__';

export const SORT_OPTION_NAME = {
	[SORT_DEFAULT]: 'By Spend',
	[SORT_ALPHABETIC]: 'Alphabetically',
	[SORT_TIME]: 'By Date',
};

export const VENDOR_TYPES = {
	harmonized: 'harmonizedSupplier',
	original: 'supplier',
};

export const VENDOR_DIMENSIONS = [
	VENDOR_TYPES.original,
	VENDOR_TYPES.harmonized,
];

export const CHART_ITEMS_LIMIT = 15;

export const TAXONOMY_DIMENSIONS = ['category', 'clientCategory'];

export const scaleNumber = (number, tier) => {
	// if zero, we don't need a suffix
	if (tier === 0) return number;

	const scale = Math.pow(10, tier * 3);
	// scale the number
	const scaled = number / scale;

	return Math.round(scaled);
};

// inspired by https://stackoverflow.com/questions/3916191
export const downloadAsFile = (dataurl, filename) => {
	const a = document.createElement('a');
	a.href = dataurl;
	a.setAttribute('download', filename);
	a.click();
};

export const splitText = (text, maxLength) => {
	if (text && text.length > maxLength) {
		const words = text.split(' ');
		if (words.length === 1) {
			return text;
		}
		if (words.length === 2) {
			return { multilines: words };
		}

		const multilines = words.reduce((multilines, word) => {
			const group = multilines.pop();

			if (!group) {
				return [...multilines, word];
			} else {
				const groupWithWord = group + ' ' + word;

				if (groupWithWord.length > maxLength) {
					return [...multilines, group, word];
				} else {
					return [...multilines, groupWithWord];
				}
			}
		}, []);

		return { multilines };
	}

	return text || '';
};

export const groupListByPropName = ({
	list = [],
	propName,
	groupName = 'group',
	sortBy,
}) => {
	const map = {};
	const orderList = [];

	list.forEach(listItem => {
		const propValue = listItem[propName];

		if (orderList.indexOf(propValue) === -1) {
			orderList.push(propValue);
		}

		if (map[propValue]) {
			const item = map[propValue];
			const innerList = item[groupName];

			innerList.push(listItem);
		} else {
			const item = {
				[groupName]: [listItem],
				[propName]: propValue,
			};

			map[propValue] = item;
		}
	});

	let result = orderList.map(propValue => map[propValue]);

	if (sortBy) {
		result = result.sort(
			(a, b) =>
				b.group.reduce((acc, item) => acc + item[sortBy], 0) -
				a.group.reduce((acc, item) => acc + item[sortBy], 0)
		);
	}

	return result;
};

export const getMonthByDate = date => {
	const d = new Date(date);

	return d.getMonth();
};

export const getYearByDate = date => {
	const d = new Date(date);

	return d.getFullYear().toString();
};

export const convertToArray = data =>
	data ? (Array.isArray(data) ? data : [data]) : [];

const CLIENT_CATEGORY = 'clientCategory';

export const isCustomCategory = dimensions =>
	!!dimensions && dimensions[0] && dimensions[0] === CLIENT_CATEGORY;

export const getHierarchyById = id => {
	if (id && id.length) {
		return id
			.split('/')
			.filter(part => part)
			.map(part => decodeURIComponent(part));
	}

	return [];
};

export const getCurrencySymbolFromOptions = (options, currency) => {
	if (!options) {
		return currency ? currency.toUpperCase() : '';
	}

	if (!currency) {
		return '';
	}

	const currencyObj =
		options.find(item => item.code === currency.toLowerCase()) || {};

	return currencyObj.symbol || currency.toUpperCase();
};

export const getDimensionOptionName = (displayName = '', capitalize = true) => {
	let result = displayName
		.split('_')
		.join(' ')
		.toLowerCase();

	// capitalize first letter
	if (result && capitalize) {
		const [firstLetter, ...rest] = result;
		result = [firstLetter.toLocaleUpperCase(), ...rest].join('');
	}

	return result;
};
